<template>
    <v-row>
        <v-col v-for="(item, index) in items" :key="index" cols="12" md="6" lg="4">
            <lawyer-card :code="item.code" :mouseOver="mouseOver" data-aos="fade-up" :data-aos-delay="[200, 100, 0][index % 3]" :imageActive="`/images/lawyer/${item.code}.jpg`" :lang="lang" />
        </v-col>
    </v-row>
</template>

<script>
import LawyerCard from "@/components/dumb/lawyer-card.vue";

export default {
    components: {
        LawyerCard,
    },
    props: {
        mouseOver: { type: Boolean },
        lang: { type: String, default: "ko" },
    },
    data() {
        return {
            items: [
                {
                    // 황희동
                    code: "hdhwang",
                },
                {
                    // 정두리
                    code: "drjeong",
                },
                {
                    // 신병섭
                    code: "bfshin",
                },
                {
                    // 김지현
                    code: "jhkim",
                },
                {
                    // 김태훈
                    code: "thkim",
                },
                {
                    // 김승욱
                    code: "swkim",
                },
            ],
        };
    },
};
</script>